'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./Loader.scss');

var cn = _bind2.default.bind(styles);

var Loader = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(Loader, _PureComponent);

  function Loader() {
    (0, _classCallCheck3.default)(this, Loader);
    return (0, _possibleConstructorReturn3.default)(this, (Loader.__proto__ || (0, _getPrototypeOf2.default)(Loader)).apply(this, arguments));
  }

  (0, _createClass3.default)(Loader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          size = _props.size,
          mask = _props.mask,
          small = _props.small,
          className = _props.className,
          inline = _props.inline,
          left = _props.left,
          right = _props.right,
          center = _props.center,
          transparent = _props.transparent,
          alignCenter = _props.alignCenter,
          onClick = _props.onClick,
          show = _props.show;

      if (!show) {
        return null;
      }

      var smallSize = 25;
      var loaderClass = cn(className, 'loader', { colored: !color, inline: inline, left: left, right: right, center: center });

      var loadIndicator = _react2.default.createElement(
        'div',
        { className: loaderClass, style: { width: (small ? smallSize : size) + 'px' }, onClick: onClick },
        _react2.default.createElement(
          'svg',
          { className: styles.circular, viewBox: '25 25 50 50' },
          _react2.default.createElement('circle', { className: styles.path, cx: '50', cy: '50', r: '20', stroke: color || null, fill: 'none' })
        )
      );

      var indicator = mask ? _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.mask, (0, _defineProperty3.default)({}, styles.transparent, transparent)) },
        loadIndicator
      ) : loadIndicator;

      if (alignCenter) {
        return _react2.default.createElement(
          'div',
          { className: 'text-center' },
          indicator
        );
      }

      return indicator;
    }
  }]);
  return Loader;
}(_react.PureComponent), _class.propTypes = {
  alignCenter: _propTypes2.default.bool,
  center: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  color: _propTypes2.default.string,
  inline: _propTypes2.default.bool,
  left: _propTypes2.default.bool,
  mask: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  right: _propTypes2.default.bool,
  show: _propTypes2.default.bool, // TODO: refactor all loaders to use show prop
  size: _propTypes2.default.number,
  small: _propTypes2.default.bool,
  transparent: _propTypes2.default.bool
}, _class.defaultProps = {
  onClick: _noop3.default,
  show: true,
  size: 40
}, _temp);
exports.default = Loader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/Loader.js
// module id = 60
// module chunks = 1